import React, { useEffect, useState } from 'react';
import AdSense from 'react-adsense';

import { connect } from 'react-redux';

import { Link, useParams } from 'react-router-dom';

import { setActiveList } from '../redux/actions';
import { getCurrentListInfo, getUser, isUserReady } from '../redux/selectors';
import RankedItem from '../components/RankedItem/RankedItem';
import PageHeader from '../components/PageHeader/PageHeader';
import Button from '../components/Button/Button';
import clsx from 'clsx';

function SharePage(props) {
  const { id, responseId } = useParams();
  const search = location.search;
  const participantId = new URLSearchParams(search).get('user');
  const numItemsInList = props.currentList?.items?.length || 0;

  let setActiveList = props.setActiveList;
  const [ready, setReady] = useState(false);
  const [inError, setInError] = useState(false);
  const [alreadyResponded, setAlreadyResponded] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [rankings, setRankings] = useState([]);

  useEffect(() => {
    async function setup() {
      let query = '';
      if (participantId) {
        query = `?participantId=${participantId}`;
      }
      let listResponse = await fetch(
        `/api/RumbleLists/${id}/Participate` + query
      );
      if (!listResponse.ok) {
        try {
          let responseJson = await listResponse.json();
          if (responseJson.reason === 'AlreadyResponded') {
            setAlreadyResponded(true);
          } else {
            setInError(true);
            setErrorMessage('Could not get list information');
          }
          return;
        } catch (e) {
          setInError(true);
          setErrorMessage('Could not get list information');
          return;
        }
      }
      let activeList = await listResponse.json();
      setActiveList(activeList);
      if (activeList.type === 'Open' && typeof Storage !== 'undefined') {
        let completedListsEntry = localStorage.getItem('completedLists');
        let completedLists = [];
        if (completedListsEntry) {
          completedLists = completedListsEntry.split(',');
        }
        if (completedLists.includes(id)) {
          setAlreadyResponded(true);
        }
        if (responseId) {
          const rankingResponse = await fetch(
            `/api/RumbleLists/${id}/${responseId}`
          );
          setRankings(await rankingResponse.json());
        }
      }
      setReady(true);
    }
    setup();
  }, [
    id,
    participantId,
    setReady,
    setInError,
    setErrorMessage,
    setActiveList,
    setAlreadyResponded,
  ]);

  let rankButton = (
    <Button
      tag={'Link'}
      variant={'primary'}
      to={`/Showdown${participantId ? `?user=${participantId}` : ''}`}
    >
      Rank!
    </Button>
  );

  if (alreadyResponded) {
    rankButton = (
      <>
        <Button variant={'primary'} disabled>
          Already Ranked
        </Button>
        <p className={'text-center text-20'}>Thanks for your submission!</p>
      </>
    );
  }

  if (inError) {
    return (
      <div className='container text-center h-full flex flex-col justify-center items-center'>
        <div>
          <h1>Error loading rumble!</h1>
          <h2>{errorMessage}</h2>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className='text-center text-primary h-full flex justify-center items-center'>
        Loading...
      </div>
    );
  }
  return (
    <>
      {props.user && props.ready && (
        <PageHeader
          props={props}
          title={"You've been invited to rank a rumble"}
          logOutModal={props.logOutModal}
          editModal={props.editModal}
          isEditOpen={props.isEditOpen}
          isFullOpen={props.isFullOpen}
        />
      )}
      <div
        className={clsx(
          props.user && props.ready ? 'tablet:pt-32' : null,
          !props.user && props.ready ? 'pt-10' : null
        )}
      >
        <div className={'container'}>
          {!props.user && props.ready && (
            <div className={'text-center'}>
              <header className={'mb-8'}>
                <Link to='/' className={'inline'}>
                  <img
                    src={
                      props.currentList?.whiteLabelInfo?.imageURL ||
                      'img/rr-logo.png'
                    }
                    alt={
                      props.currentList?.whiteLabelInfo?.imageURL
                        ? `${props.currentList.authorCompany} logo`
                        : 'RumbleRank Logo'
                    }
                    className={'inline'}
                    width={'124'}
                    height={'96'}
                  />
                </Link>
              </header>
              <h1 className={'mb-8'}>You've been invited to rank a rumble</h1>
            </div>
          )}
          <div
            className={
              'max-w-[500px] mx-auto flex flex-col justify-center gap-4'
            }
          >
            <div
              className={
                'flex flex-col justify-center gap-3  p-4 rounded-8 border border-borderColor'
              }
            >
              <h2 className={'text-center'}>{props.currentList.name}</h2>
              <img
                src={
                  props.currentList.imageURL
                    ? props.currentList.imageURL
                    : 'img/imagePlaceHolder.jpg'
                }
                className={'object-cover w-full aspect-[311/160] rounded-6'}
                alt={`Thumbnail for ${props.currentList.name}`}
                loading={'eager'}
              />
              <div>
                <span
                  className={
                    'px-2.5 py-1 text-blue font-semibold bg-blueLight rounded-20 inline-block'
                  }
                >{`Created by ${props.currentList.author}${
                  props.currentList.authorCompany
                    ? ` at ${props.currentList.authorCompany}`
                    : ''
                }`}</span>
              </div>
              {props.currentList.description && (
                <p>{props.currentList.description}</p>
              )}

              <p className={'text-16 text-gray'}>
                This list contains {numItemsInList} items. You will make about{' '}
                {Math.round(numItemsInList * Math.log2(numItemsInList))} head to
                head comparisons.
              </p>
            </div>
            {rankings.length > 0 && (
              <div>
                <h2 className={'text-center mb-4'}>
                  Here's how I ranked {props.currentList.name}
                </h2>
                <div className={'flex flex-col gap-3'}>
                  {rankings.map((i) => {
                    return (
                      <RankedItem
                        key={i.id}
                        id={i.id}
                        name={i.name}
                        description={i.description}
                        imageURL={i.imageURL}
                        wins={i.wins}
                        score={i.aggregatedPlaces}
                        showScore={false}
                      />
                    );
                  })}
                </div>
              </div>
            )}
            {rankButton}
            {props.ready && !props.user ? (
              <p className={'text-20 text-center'}>
                Want to create your own Rumbles?{' '}
                <a className={'font-semibold text-blue'} href={'/Login'}>
                  Sign up for free.
                </a>
              </p>
            ) : null}
          </div>
          {props.currentList.showAds && (
            <div className={'text-center'}>
              <AdSense.Google
                client='ca-pub-2400035618862060'
                slot='4877866478'
                style={{ display: 'block' }}
                layout='in-article'
                format='fluid'
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    ready: isUserReady(state),
    currentList: getCurrentListInfo(state),
  };
}

export default connect(mapStateToProps, { setActiveList })(SharePage);
